import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { downloadGiftCode } from "@babackapp/private-api-client/client/use-download-gift-code";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { useCallback } from "react";

type GiftCodeDownloadButtonProps = {
  visible: boolean;
  id: string;
};

export default function GiftCodeDownloadButton({
  visible,
  id,
}: GiftCodeDownloadButtonProps) {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();

  const download = useCallback(async () => {
    const { url } = await downloadGiftCode({ giftCodeId: id, shopId: shop.id });
    window.open(url, "_blank");
  }, [id, shop.id]);

  if (!visible) return null;

  return (
    <Button
      size="sm"
      variant="outline"
      className="opacity-0 scale-110 group-hover:opacity-100 group-hover:scale-100 transition-all mx-0 my-0"
      onClick={download}
    >
      {t("pdfGift.download")}
    </Button>
  );
}
